import { render, staticRenderFns } from "./StarterPackToast.vue?vue&type=template&id=3c19ee4c&scoped=true"
import script from "./StarterPackToast.vue?vue&type=script&lang=js"
export * from "./StarterPackToast.vue?vue&type=script&lang=js"
import style0 from "./StarterPackToast.vue?vue&type=style&index=0&id=3c19ee4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19ee4c",
  null
  
)

export default component.exports